import { amountAtMostInvoiceableTotal } from './amount-at-most-invoiceable-total.validator';
import { amountCoversDeductionRemainder } from './amount-covers-deduction-remainder.validator';
import { amountSurpassesChangeOrderTotal } from './amount-surpasses-change-order-total.validator';
import { atLeastOneItemInvoiced } from './at-least-one-item-invoiced.validator';

export class InvoiceValidators {
  static amountSurpassesChangeOrderTotal = amountSurpassesChangeOrderTotal;
  static amountAtMostInvoiceableTotal = amountAtMostInvoiceableTotal;
  static amountCoversDeductionRemainder = amountCoversDeductionRemainder;
  static atLeastOneItemInvoiced = atLeastOneItemInvoiced;
}
